import React from "react";
import ReactDOM from "react-dom";
import GlobalStyle from "styles/global";

import App from "./App";
import "./utils/i18n/i18n";

ReactDOM.render(
  <>
    <GlobalStyle />
    <App />
  </>,
  document.getElementById("root")
);
